import {
  type PaginatedTaskStatusCreateListReadable,
  type TaskStatusesListData,
  type TaskStatusRetrieveReadable,
  taskStatusesListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { BadgeText } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { defaultFilters } from '@shared/utils'
import { useTranslation } from 'react-i18next'

import type { SelectProps } from 'antd'

export const TaskStatus = (props: SelectProps) => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  const statusOptions = (options: TaskStatusRetrieveReadable[]) =>
    options?.map((option) => ({
      value: option.id,
      label: <BadgeText color={option?.color} text={option.name} />
    }))

  return (
    <InfiniteSelect<
      TaskStatusesListData,
      PaginatedTaskStatusCreateListReadable,
      TaskStatusRetrieveReadable
    >
      value={props.value || Number(params?.status) || undefined}
      className="select-min-width"
      popupMatchSelectWidth
      placeholder={t('task.status')}
      getQueryFunction={taskStatusesListInfiniteOptions}
      onChange={(status) => updateQuery({ status, page: defaultFilters.page })}
      baseOptions={{
        query: {
          preference: params?.status
        }
      }}
      getOptions={({ options }) => statusOptions(options)}
      {...props}
    />
  )
}
